import {HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

export interface DubbingSttResponse {
  text: string;
  words: Array<{
    text: string;
    type: 'word' | 'spacing';
    start: number;
    end: number;
  }>;
}

export interface DubbingTranslateSourceItem {
  id: number;
  text: string;
}

export interface DubbingTranslateItem {
  id: number;
  text: string;
  translation: string;
}

export interface DubbingTTSVoiceSettings {
  stability: number;
  similarity_boost: number;
  style: number;
  use_speaker_boost: boolean;
  speed: number;
}

export interface DubbingTTSBody {
  text: string;
  model_id: string;
  voice_id: string;
  voice_settings: DubbingTTSVoiceSettings;
  previous_request_ids?: string[];
  next_text?: string;
}

@Injectable()
export class OttDubbingService {
  constructor(readonly http: TisaUmpireHttpService) {}

  stt(audioFile: File): Observable<DubbingSttResponse> {
    const formData = new FormData();
    formData.append('file', audioFile, 'audio.wav');
    formData.append('model_id', 'scribe_v1');
    formData.append('language', 'pl');
    return this.http.post<DubbingSttResponse>('/ott/dubbing/stt', formData);
  }

  translate(
    segments: DubbingTranslateSourceItem[],
    source: string,
    target: string,
  ): Observable<DubbingTranslateItem[]> {
    return this.http.post<DubbingTranslateItem[]>(
      '/ott/dubbing/translate',
      segments,
      {params: {source, target}},
    );
  }

  tts(body: DubbingTTSBody): Observable<HttpResponse<ArrayBuffer>> {
    return this.http.post<ArrayBuffer>('/ott/dubbing/tts', body, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      responseType: 'arraybuffer',
      observe: 'response',
    }) as unknown as Observable<HttpResponse<ArrayBuffer>>;
  }
}
